/* ─────────────────────────────────────────────
   Pretty Freshie – theme.js
   Shopify Online Store 2.0 Theme JS
   ───────────────────────────────────────────── */

'use strict';

/* ─── STATE ─── */
const state = {
  shape: {
    id: null,
    name: null,
    allowsImage: null,
    previewImage: null
  },
  image: { id: null, label: null, url: null },
  color: { id: null, name: null, hex: '#FFFFFF' },
  scent: '',
  notes: '',
};

/* ─── SHAPE SELECTION ─── */
function selectShape(el) {
  document.querySelectorAll('.shape-option').forEach(e => e.classList.remove('selected'));
  el.classList.add('selected');

  state.shape.id         = el.dataset.shapeId;
  state.shape.name       = el.dataset.shapeName;
  state.shape.allowsImage = el.dataset.allowsImage === 'true';
  state.shape.previewImage = el.dataset.previewImage;

  // Activate step0
  document.getElementById('step0').classList.add('active');

  // Show/hide image step
  const imageStep = document.getElementById('step1');
  if (imageStep) {
    if (state.shape.allowsImage) {
      imageStep.style.display = '';
      imageStep.classList.add('active');
      // Update step numbers: shape=1, image=2, color=3, scent=4
      setStepNumbers(true);
    } else {
      imageStep.style.display = 'none';
      state.image = { id: null, label: null, url: null };
      // Update step numbers: shape=1, color=2, scent=3
      setStepNumbers(false);
    }
  }

  // Activate color + scent steps
  document.getElementById('step2').classList.add('active');
  document.getElementById('step3').classList.add('active');

  // Update preview shape appearance
updatePreviewShape();
updatePreview();
}

function setStepNumbers(hasImage) {
  const colorNum = document.getElementById('stepNumColor');
  const scentNum = document.getElementById('stepNumScent');
  const notesNum = document.getElementById('stepNumNotes');
  if (hasImage) {
    if (colorNum) colorNum.textContent = '3';
    if (scentNum) scentNum.textContent = '4';
    if (notesNum) notesNum.textContent = '5';
  } else {
    if (colorNum) colorNum.textContent = '2';
    if (scentNum) scentNum.textContent = '3';
    if (notesNum) notesNum.textContent = '4';
  }
}

/* ─── IMAGE SELECTION ─── */
function selectImage(el) {
  document.querySelectorAll('.img-option').forEach(e => e.classList.remove('selected'));
  el.classList.add('selected');
  state.image.id        = el.dataset.designId;
  state.image.variantId = el.dataset.variantId;
  state.image.label     = el.dataset.label;
  state.image.url       = el.dataset.imgUrl || null;

  // Swap the cart variant ID so Shopify deducts inventory from the right variant
  const cartVariantInput = document.getElementById('cartVariantId');
  if (cartVariantInput && el.dataset.variantId) {
    cartVariantInput.value = el.dataset.variantId;
  }

  updatePreview();
}

/* ─── COLOR SELECTION ─── */
function selectColor(el) {
  document.querySelectorAll('.swatch').forEach(e => e.classList.remove('selected'));
  el.classList.add('selected');
  state.color.id   = el.dataset.colorId;
  state.color.name = el.dataset.colorName;
  state.color.hex  = el.dataset.hex || '#FFFFFF';
  document.getElementById('previewMonogramWrap').style.color = state.color.hex;
  updatePreview();
}

/* ─── SCENT SELECTION ─── */
function updateScent(sel) {
  state.scent = sel.value;
  updatePreview();
}

/* ─── UPDATE PREVIEW ─── */
function updatePreviewShape() {
  const freshie = document.getElementById('previewFreshie');
  if (!freshie) return;

  freshie.classList.remove('shape-monogram', 'shape-heart', 'shape-circle');

  const shapeName = (state.shape.name || '').toLowerCase();

  const imageWrap = document.getElementById('previewImageWrap');
  const monogramWrap = document.getElementById('previewMonogramWrap');

  if (
  shapeName.includes('monogram') ||
  shapeName.includes('trendy freshie')
) {
    freshie.classList.add('shape-monogram');

    if (imageWrap) imageWrap.style.display = 'none';
    if (monogramWrap) monogramWrap.style.display = 'flex';
  } else {
    freshie.classList.add('shape-circle');

    if (imageWrap) imageWrap.style.display = 'flex';
    if (monogramWrap) monogramWrap.style.display = 'none';
  }
}

function updatePreview() {
  // Color
  const freshie = document.getElementById('previewFreshie');

  const svg = document.getElementById('trendyMonogram');
  if (svg && state.color.hex) {
    svg.style.color = state.color.hex;
  }

  if (freshie && state.color.hex) {
    const hex = state.color.hex;
    freshie.style.background =
      `linear-gradient(135deg, ${hex}, ${lightenHex(hex, 20)})`;
  }

  // Image — render selected design image into the circle preview
  const imgWrap = document.getElementById('previewImageWrap');
  if (imgWrap && state.shape.allowsImage !== false) {
    if (state.image.url) {
      let img = imgWrap.querySelector('img');
      if (!img) {
        img = document.createElement('img');
        img.style.cssText = 'width:196px;height:196px;object-fit:cover;border-radius:50%;display:block;';
        imgWrap.appendChild(img);
      }
      img.src = state.image.url;
      img.alt = state.image.label || '';
      img.style.display = 'block';
    } else {
      const existingImg = imgWrap.querySelector('img');
      if (existingImg) existingImg.style.display = 'none';
    }
  }

  // Details
  setPreviewText('previewShape', state.shape.name || '—');
  setPreviewText('previewColor', state.color.name || '—');
  setPreviewText('previewScent', state.scent || '—');
  setPreviewText('previewImg', state.shape.allowsImage ? (state.image.label || '—') : 'N/A (Monogram)');

  // Summary
  setPreviewText('summaryShape', state.shape.name || '—');
  setPreviewText('summaryColor', state.color.name || '—');
  setPreviewText('summaryScent', state.scent || '—');
  setPreviewText('summaryImg',   state.shape.allowsImage ? (state.image.label || '—') : '—');

  const summaryImgRow = document.getElementById('summaryImgRow');
  const previewImgRow = document.getElementById('previewImgRow');
  if (summaryImgRow) summaryImgRow.style.display = state.shape.allowsImage ? '' : 'none';
  if (previewImgRow) previewImgRow.style.display  = state.shape.allowsImage ? '' : 'none';

  // Hidden form inputs
  setValue('propShape', state.shape.name || '');
  setValue('propColor', state.color.name || '');
  setValue('propScent', state.scent || '');
  setValue('propImage', state.shape.allowsImage ? (state.image.label || '') : '');

}

function setPreviewText(id, val) {
  const el = document.getElementById(id);
  if (el) el.textContent = val;
}

function setValue(id, val) {
  const el = document.getElementById(id);
  if (el) el.value = val;
}

/* ─── COLOR UTILITIES ─── */
function lightenHex(hex, amount) {
  try {
    let r = parseInt(hex.slice(1,3), 16);
    let g = parseInt(hex.slice(3,5), 16);
    let b = parseInt(hex.slice(5,7), 16);
    r = Math.min(255, r + amount);
    g = Math.min(255, g + amount);
    b = Math.min(255, b + amount);
    return '#' + [r,g,b].map(v => v.toString(16).padStart(2,'0')).join('');
  } catch(e) {
    return hex;
  }
}

/* ─── VALIDATE + SUBMIT ─── */
document.addEventListener('DOMContentLoaded', function() {
  const form = document.getElementById('freshieForm');
  if (!form) return;

  form.addEventListener('submit', function(e) {
    e.preventDefault();
    const errEl = document.getElementById('atcError');
    const btn   = document.getElementById('atcBtn');

    if (!state.shape.id) { showError(errEl, 'Please select a shape first.'); return; }
    if (state.shape.allowsImage && !state.image.id) { showError(errEl, 'Please choose an image design.'); return; }
    if (!state.color.id) { showError(errEl, 'Please choose a color.'); return; }
    if (!state.scent)    { showError(errEl, 'Please select a scent.'); return; }
    if (errEl) errEl.style.display = 'none';

    const variantId = document.getElementById('cartVariantId').value;

    const payload = {
      id: parseInt(variantId),
      quantity: 1,
      properties: {
        'Shape':        state.shape.name  || '',
        'Color':        state.color.name  || '',
        'Scent':        state.scent       || '',
        'Image Design': state.shape.allowsImage ? (state.image.label || '') : ''
      }
    };



    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    })
    .then(function(res) { return res.json(); })
    .then(function(data) {
      if (data.status && data.status !== 200) {
        showError(errEl, data.description || 'Something went wrong. Please try again.');
        if (btn) { btn.disabled = false; btn.textContent = '🛒 Add To Cart'; }
      } else {
        window.location.href = '/cart';
      }
    })
    .catch(function() {
      showError(errEl, 'Something went wrong. Please try again.');
      if (btn) { btn.disabled = false; btn.textContent = '🛒 Add To Cart'; }
    });
  });
});

function validateAndSubmit(e) { return true; }

function showError(el, msg) {
  if (!el) return;
  el.textContent = msg;
  el.style.display = 'block';
  setTimeout(() => { if(el) el.style.display = 'none'; }, 4000);
}

/* ─── FALLBACK (no product set) ─── */
function addToCartFallback() {
  if (!validateShapeOnly()) return;
  showToast(`${state.shape.name} · ${state.color.name || 'White'} · ${state.scent || 'Fresh Linen'} added!`);
}

function validateShapeOnly() {
  if (!state.shape.id) { showToast('Please select a shape first.'); return false; }
  if (!state.color.id) { showToast('Please choose a color.'); return false; }
  if (!state.scent)    { showToast('Please select a scent.'); return false; }
  return true;
}

/* ─── TOAST ─── */
function showToast(msg) {
  const toast = document.getElementById('toast');
  const msgEl = document.getElementById('toastMsg');
  if (!toast || !msgEl) return;
  msgEl.textContent = msg;
  toast.classList.add('show');
  setTimeout(() => toast.classList.remove('show'), 3500);
}

/* ─── REVIEWS SLIDER ─── */
let slideIndex = 0;
function slideReviews(dir) {
  const track = document.getElementById('reviewsTrack');
  if (!track) return;
  const cards = track.querySelectorAll('.review-card');
  if (!cards.length) return;
  const maxSlide = Math.max(0, cards.length - 3);
  slideIndex = Math.max(0, Math.min(slideIndex + dir, maxSlide));
  const cardWidth = cards[0].offsetWidth + 24;
  track.style.transform = `translateX(-${slideIndex * cardWidth}px)`;
}

/* ─── FAQ ─── */
function toggleFaq(btn) {
  const item = btn.parentElement;
  const isOpen = item.classList.contains('open');
  document.querySelectorAll('.faq-item').forEach(i => i.classList.remove('open'));
  if (!isOpen) item.classList.add('open');
}

/* ─── STICKY HEADER ─── */
window.addEventListener('scroll', () => {
  const header = document.getElementById('header');
  if (header) header.classList.toggle('scrolled', window.scrollY > 20);
}, { passive: true });

/* ─── MOBILE MENU ─── */
function toggleMenu() {
  const nav = document.getElementById('mobileNav');
  if (nav) nav.classList.toggle('open');
}

/* ─── CART COUNT REFRESH ─── */
document.addEventListener('DOMContentLoaded', () => {
  // Auto-select first shape if only one exists
  const shapes = document.querySelectorAll('.shape-option');
  if (shapes.length === 1) {
    selectShape(shapes[0]);
  }

  // Auto-select first color swatch
  const firstSwatch = document.querySelector('.swatch');
  if (firstSwatch && !document.querySelector('.swatch.selected')) {
    selectColor(firstSwatch);
  }

  // Auto-select first image option
  const firstImg = document.querySelector('.img-option');
  if (firstImg && !document.querySelector('.img-option.selected')) {
    selectImage(firstImg);
    firstImg.classList.add('selected');
  }
});
